import { render, staticRenderFns } from "./ClicMainSideMenu.vue?vue&type=template&id=6621d80a&scoped=true&"
import script from "./ClicMainSideMenu.vue?vue&type=script&lang=js&"
export * from "./ClicMainSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClicMainSideMenu.vue?vue&type=style&index=0&id=6621d80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621d80a",
  null
  
)

export default component.exports